let AppSettings = {
    mainColor: 'brand',
    backgroundColor: 'light-2',
    cardColor: 'light-1',
    currencyOptionFormater: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v' // %s is the symbol and %v is the value
    },
    currencyOptionFormaterNoDecimal: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 0,
        format: '%v' // %s is the symbol and %v is the value
    },
    toggleInsteadOfCheckbox: true,
    baremeAccessForAdmin: false,
    tva: 0.21,
    pdfRenderingOptions: `pdf.scale=0.8&emulateScreenMedia=true&waitFor=${encodeURIComponent("#loaded")}`,
    //NO TRAILING SLASH
    apiUrl: process.env.REACT_APP_API_URL || 'http://172.21.0.3:3030',
    pdfUrl: process.env.REACT_APP_PDF_URL || 'http://localhost:8080',
    ownUrl: process.env.REACT_APP_OWN_URL || 'http://localhost:3000'
};
export default AppSettings;


// WEBPACK FOOTER //
// ./src/computationApps/utils/appSettings.js